import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("ap_token");
    if (token) {
        cfg.headers = cfg.headers || {};
        cfg.headers["Authorization"] = `Bearer ${token}`;
    }
    return cfg;
});

export function formatApiError(e) {
    const detail = e?.response?.data?.detail;
    if (detail == null) return e?.message || "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((d) => (d?.msg ? d.msg : JSON.stringify(d))).join(", ");
    if (typeof detail === "object" && detail.msg) return detail.msg;
    return String(detail);
}

export const LOGO_URL = "/aminoplex_logo.png";

export const fmtUSD = (n) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
